import React from 'react';
import { Route, Navigate, Outlet } from 'react-router-dom';
import TripRequests from '../../pages/trip-requests';
import TripRequestMyQueue from '../../pages/trip-requests/my-queue';
import TripRequestsAll from '../../pages/trip-requests/all';
import TripRequestIncoming from '../../pages/trip-requests/incoming';
import TripRequestInProgress from '../../pages/trip-requests/in-progress';
import Reminders from '../../pages/trip-requests/reminders';
import TripRequestMatchCancel from '../../pages/trip-request/matches/cancel';
import TripRequestReferral from '../../pages/trip-request/referral';
import TripRequestCreate from '../../pages/trip-request/create';
import TripRequest from '../../pages/trip-request';

const useTripRequestsRoutes = () => (
  <>
    <Route path="trip-requests" element={<TripRequests />}>
      <Route index element={<Navigate to="/trip-requests/incoming" />} handle={{ tab: '/incoming' }} />
      <Route path="incoming" element={<TripRequestIncoming />} handle={{ tab: '/incoming' }} />
      <Route path="all" element={<TripRequestsAll />} handle={{ tab: '/all' }} />
      <Route path="my-queue/:selectedList?" element={<TripRequestMyQueue />} handle={{ tab: '/my-queue' }} />
      <Route path="in-progress" element={<TripRequestInProgress />} handle={{ tab: '/in-progress' }} />
      <Route path="reminders" element={<Reminders />} handle={{ tab: '/reminders' }} />
    </Route>
    <Route path="trip-requests/create" element={<TripRequestCreate />} />
    <Route path="trip-requests/:tripRequestId" element={<Outlet />}>
      <Route index element={<TripRequest />} />
      <Route path="referral" element={<TripRequestReferral />} />
      <Route path="matches/:tripMatchId" element={<TripRequestMatchCancel />} />
      <Route path="*" element={<Navigate to=".." replace />} />
    </Route>
  </>
);

export default useTripRequestsRoutes;
